import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";  
import Home from "./pages/home/Home"; 
import HeaderTop from "./Header";
import Footer from "./Footer"; 
import CmsPage from "./pages/CmsPage"; 
import VideoGallery from "./pages/VideoGallery";
import PhotoGalleryCategories from "./pages/PhotoGalleryCategories";
import PhotoGalleryPage from "./pages/PhotoGalleryPage";
import TestimonialForm from "./pages/TestimonialForm"; 
import FeedbackPage from "./pages/FeedbackPage"; 
import OurServices from "./pages/home/OurServices";
import OurCars from "./pages/home/OurCars";
import RoutesPage from "./pages/RoutesPage";
import ToursDetails from "./pages/ToursDetails";
import ToursList from "./pages/ToursList";
import ScrollToTop from "./pages/ScrollToTop";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <HeaderTop/>

      <Routes>

        {/* Home */}
        <Route path="/" element={<Home />} />

        {/* Specific routes FIRST */}
        <Route path="/services" element={<OurServices />} />
        <Route path="/services/:categorySlug" element={<ToursList />} />
        <Route path="/:categorySlug/:slug" element={<ToursDetails />} />
        <Route path="/our-cars" element={<OurCars />} />
        <Route path="/routes" element={<RoutesPage />} />
        <Route path="/photo-gallery" element={<PhotoGalleryCategories />} />
        <Route path="/photo-gallery/:catId" element={<PhotoGalleryPage />} />
        <Route path="/video-gallery" element={<VideoGallery />} />
        <Route path="/reviews" element={<FeedbackPage />} />
        <Route path="/feedback-form" element={<TestimonialForm />} />

        {/* CMS page ALWAYS LAST */}
        <Route path="/:slug" element={<CmsPage />} />

      </Routes>

      <Footer />
    </Router>
  );
}

export default App;